import pluralize from "pluralize";
import { Card } from "react-bootstrap";
import styled from "styled-components";

import { EntityAvatar, ProjectAvatar } from "../../../common/components";
import { Badge } from "../../../common/components/core";
import { useSelector } from "../../../redux/hooks";
import { currentRolesSelector, currentUserWalletSelector } from "../../../redux/slices/auth/selectors";
import { BesuProjectState } from "../../../types/project";
import {
    formatToDate,
    getNameInitial,
} from "../../../utils/common";
import { getCounterEntity } from "../../../utils/project";
import { isNodeDeveloper } from "../../../utils/role";
import useHasProjectAction from "../hooks/useHasProjectAction";

type ProjectCardProps = {
    project: BesuProjectState;
};

const ProjectCard = ({ project }: ProjectCardProps): JSX.Element => {
    const { hasProjectAction, claimActionNum } = useHasProjectAction(project);
    const currentRoles = useSelector(currentRolesSelector);
    const counterEntity = getCounterEntity(project, currentRoles);
    const currentUserWallet = useSelector(currentUserWalletSelector);

    const getClaimNum = () => {
        let num = 0;
        if (!project.claimCountByContractorList || project.claimCountByContractorList.length === 0) {
            return num;
        }
        if (isNodeDeveloper()) {
            project.claimCountByContractorList?.forEach((contractorClaims) => {
                num = num + contractorClaims.claimCount;
            });

        } else if (!isNodeDeveloper() && currentUserWallet) {
            const cnt = project.claimCountByContractorList?.find(
                (contractorClaims) => contractorClaims.contractorWallet?.toLocaleLowerCase() === currentUserWallet?.toLowerCase(),
            )?.claimCount;
            if (cnt) {
                num = cnt
            }
        }
        return num;
    }

    const claimNum = getClaimNum();

    return (
        <StyledCard className="position-relative mt-5 border-0">
            <Card.Body className="p-3">
                <div className="d-flex justify-content-between position-relative">
                    <StyledProjectAvatar variant="small" className="text-center">
                        {getNameInitial(project.name)}
                    </StyledProjectAvatar>
                    <Badge
                        type="info"
                        className="d-inline-flex align-items-center card-Badge fw-bold fs-6"
                    >
                        {claimNum}{" "}
                        {pluralize(
                            "Claim",
                            claimNum,
                        )}
                    </Badge>
                    {hasProjectAction &&
                        <ActionDot title={`${claimActionNum} ${pluralize("Claim",claimActionNum,)} action required`} aria-label="action required"/>}
                </div>
                <div className="p-0 pt-2">
                    <p className="fs-7 mb-0 fw-bolder">
                        {project.externalProjectId}
                    </p>
                    <span className="fs-5">
                        {project.name}
                    </span>
                    {!isNodeDeveloper() && counterEntity && counterEntity.account && (
                        <CounterEntity className="fw-bolder pt-2 fs-7">
                            <EntityAvatar className="me-2" variant="normal">
                                {getNameInitial(counterEntity.account.name)}
                            </EntityAvatar>
                            {counterEntity.account.name}
                        </CounterEntity>
                    )}
                    <p className="fs-7 mb-0">
                        Created on {formatToDate(project.createdAt)}
                    </p>
                </div>
            </Card.Body>
        </StyledCard>


    );
};

const StyledCard = styled(Card)`
    border-radius: 0;
    background-color: #fff;
    // transition: filter 150ms ease-in-out;
    // :hover {
    //     filter: drop-shadow(0px 2px 20px rgba(129, 129, 129, 0.25));
    // }
    .card-Badge {
        padding: 8px 12px;
        border-radius: 1.125rem;
        background-color: #fff;
        border: 1px solid #333;
        color: #333;
    }
    .card-body {
        color: #333;
    }
`;

const StyledProjectAvatar = styled(ProjectAvatar)`
    
    // position: absolute;
    // top: 0;
    // left: 24px;
    // transform: translateY(-50%);
`;

const CounterEntity = styled.p`
    line-height: 2;
`;

const ActionDot = styled.div`
    position: absolute;
    top: -8px;
    right: -8px;
    padding: 8px;
    background-color: var(--bs-primary);
    border-radius: 50%;
`;

export default ProjectCard;
